import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { transparentize } from '@savgroup-front-common/primitive/helpers/cssColor';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { rem } from '@savgroup-front-common/primitive/helpers/units';

export const $Bannered = styled.div<{
  $bannerUrl?: string;
}>`
  padding: ${spacing('xl')} ${spacing('lg')};
  padding-bottom: ${({ $bannerUrl }) =>
    $bannerUrl ? spacing(32) : spacing(16)};
  background-color: ${({ theme }) =>
    transparentize(0.95, theme.colors.primary)};

  min-height: ${({ $bannerUrl }) => ($bannerUrl ? rem(360) : undefined)};

  @media ${media.maxWidth.xs} {
    min-height: 100px;
    padding: ${({ $bannerUrl }) =>
      $bannerUrl ? `${spacing(11)} ${spacing(11)} ${spacing(16)}` : undefined};
  }

  ${({ $bannerUrl, theme }) =>
    $bannerUrl
      ? `
    background-color: ${theme.colors.primary};
    background-image: url(${$bannerUrl});
    background-size: cover;
    background-repeat: no-repeat;
    background-position-y: center;
    background-position-x: center;
    `
      : undefined};
`;
